import { WidgetPositionChange } from '../../widget-grid/models/widgetPositionChange.interface';
import { IProduct } from '../../shared/models/product.model';
import { IContainerDimensions } from '../models/grid.model';
import { IArticle } from '../../prisma-xs/models/article.model';
import { IDevicesOnGrid } from '../models/device-data.model';
import { IWidget } from '../../prisma-xs/models/prisma-xs.model';
import { getEnclosureDimensionsBasedOnZoomFactor } from '../../prisma-xs/helpers/elements-sizes-calculations.helper';
import { MAX_FIELD_ENCLOSURE_SIZE, MIN_FIELD_ENCLOSURE_SIZE } from '../models/enclosure.constants';
import { EnclosureIP } from '../../shared/models/prisma-xs.model';

export const changeCurrentEnclosure = (event: WidgetPositionChange, enclosure: any) => {
  return Object.assign({}, enclosure, {
    configuration: Object.assign({}, enclosure?.configuration, {
      rows: event.newPosition.height,
      fields: event.newPosition.width
    })
  });
};

export const prismaXSEnclosureProductImage = (product: IProduct, enclosureRowsNumber: number): IContainerDimensions => {
  const heightOfOneField = product?.productSupportSpec?.height / product?.prismaProduct?.rows;

  if (!product?.productSupportSpec?.width || !heightOfOneField || !enclosureRowsNumber) {
    return {
      containerWidth: 0,
      containerHeight: 0
    }
  }

  return {
    containerWidth: product?.productSupportSpec?.width,
    containerHeight: heightOfOneField * enclosureRowsNumber
  }
}

export const mapPrismaProductsToWidgets = (configurations: IDevicesOnGrid[]): Partial<IArticle[]>  => {
  return configurations.map(configuration => {
    const product: IProduct = configuration?.product;
    const widget: IWidget = {
      top: configuration.rowNumber,
      left: configuration.columnNumber,
      width: product?.prismaProduct.fields,
      height: product?.prismaProduct.rows,
    }
    return { widget, rules:  product?.prismaProduct.rules }
  }) as Partial<IArticle[]>;
}

export const enclosuresFieldHeightIsSmallerThenMin = (parentElement: HTMLElement,
                                                      factor: number,
                                                      configurationRows: number,
                                                      configurationFields: number,
                                                      maxRows: number,
                                                      maxFields: number): boolean => {
  const { height } = getEnclosureDimensionsBasedOnZoomFactor(
    parentElement,
    factor,
    configurationRows,
    configurationFields,
    maxRows,
    maxFields);

  return (height / maxRows) < MIN_FIELD_ENCLOSURE_SIZE;
};

export const enclosuresFieldHeightIsBiggerThenMax = (parentElement: HTMLElement,
                                                      factor: number,
                                                      configurationRows: number,
                                                      configurationFields: number,
                                                      maxRows: number,
                                                      maxFields: number): boolean => {
  const { height } = getEnclosureDimensionsBasedOnZoomFactor(
    parentElement,
    factor,
    configurationRows,
    configurationFields,
    maxRows,
    maxFields);

  return (height / maxRows) > MAX_FIELD_ENCLOSURE_SIZE;
};

export const enclosureIs280mm = (enclosureIpType: string): boolean => {
  return enclosureIpType === EnclosureIP.IP55;
}

